import rgbHex from 'rgb-hex';
import colors from '../../config/colors.json';
import classNames from 'classnames';
let buildings = require("../../config/all-buildings.json")

function getDataByPgbid(pgbid) {
    const resultArray = buildings.flatMap(item =>
        item.variations.map(variation => ({
            pbgid: variation.pbgid,
            name: item.name,
            icon: item.icon
        }))
    );

    return resultArray.find(item => item.pbgid === pgbid) || null;
}

export function LiveGameAgeUpProgress({ pgbid, progress, workers, estimatedTimeLeft, leftSide, color }) {
    const landmarkData = getDataByPgbid(pgbid);
    let mainColor = rgbHex(colors[color]?.mainColor);

    const progressPercentage = Math.min(Math.max(progress, 0), 1) * 100; // Clamp between 0 and 100

    return (
        <div className={classNames(`liveGameAgeUpProgress h-[58px] flex px-2`, leftSide ? ' flex-row' : ' flex-row-reverse')} style={{ background:'linear-gradient(90deg,rgba(29, 39, 47, 0.0) 0%, rgba(29, 39, 47, 1) 10%, rgba(29, 39, 47, 1) 90%, rgba(29, 39, 47, 0.0) 100%)'}}>
            <div className="mt-[4px] mx-[4px] h-[50px] w-[50px]">
                <img src={landmarkData?.icon} alt={``} style={{backgroundColor: 'rgb(29, 39, 47)'}}/>
            </div>
            <div className="mx-1 text-white text-xl italic ">
                <div className="h-5 mt-[2px]">{landmarkData?.name}</div>
                <div className={classNames(`h-5 flex gap-1 items-center mt-[2px]`, leftSide ? 'flex-row justify-start' : 'flex-row-reverse justify-items-end')}>
                    <div>{workers}</div>
                    <img src="/liveGameIcons/landmark_worker_count.png" className="h-[17px] w-[17px]" alt="" />
                    <div>{estimatedTimeLeft !== -1 ? `${Math.round(estimatedTimeLeft)}s` : <span className="text-4xl">∞</span>}</div>
                </div>
                <div className={classNames(`progressBar w-[150px] h-[8px] bg-black outline-[#5E6989] outline-1 outline`, leftSide ? 'float-left' : 'float-right')}>
                    <div className={classNames("h-full overflow-hidden", leftSide ? 'float-left' : 'float-right')} style={{ backgroundColor: `#${mainColor}`, width: `${progressPercentage}%`, transition: 'width 0.5s ease-in-out' }}>
                        <div className='h-full opacity-65 w-[300%] bg-repeat-x ' style={{backgroundImage: `url('/liveGameIcons/bar_dash.png')`, backgroundSize: 'cover', animation: 'barDash 8s linear infinite'}}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}